import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class JobAppraisalSplitData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading:true,
            modalTitle:'Split Job Appraisal Data',
            appraisalSplitData:null,
            jobId:props.jobId || null,
            type:'pickup',
        };
        this.renderAppraisalInfoBlock = this.renderAppraisalInfoBlock.bind(this);
    }
    componentDidMount() {
      $.urlParam = function(name){
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        return results[1] || 0;
      }
      let jobId = this.state.jobId;
      return fetch('/api/v1/driver-app/jobs/'+jobId+'/apprisal-split-data?api_token=JZIZfJxYBFoY8hVMt8Nn9fAaYrN0dGqh3iauIL3IkXdAX3LHA1544700484',
        {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
        }).then((responseText) => {
        let response = responseText.json();
        response.then((response) => {
          this.setState({
            appraisalSplitData: response.pickup_appraisal,
            isLoading: false
          });
        });
      });
    }
    renderAppraisalInfoBlock(type) {
        let appraisal = this.state.appraisalSplitData;
        let appraisalInfoBlock;

        if(appraisal && typeof appraisal == "object" ){
          appraisalInfoBlock = (
            <div  className="text-left"  key={'appraisal-info-block-for-'+appraisal.id}>
              <hr />
              <h4 className="text-center">Manual Appraisal</h4>
              <h5>Vehicle Info</h5>
              {this.renderManualAppraisalVehicleInfo(appraisal, type)}
              <div>&nbsp;</div>
              <h5>Vehicle Parts</h5>
              {this.renderManualAppraisalVehicleParts(appraisal, type)}
              <hr />
            </div>
          );
        }else {
          appraisalInfoBlock =(
            <div className="row" key={'appraisal-info-block-for'+appraisal.id}>
              <div className="col-md-12">
                <p>
                  <strong>
                    No Appraisal Yet.
                  </strong>
                </p>
              </div>
            </div>
          )
        }
        return appraisalInfoBlock;
    }
    renderManualAppraisalMileageImages(appraisal, type) {
      let MileageImages = [];
      if (appraisal.mileage &&
        appraisal.mileage[type] &&
        appraisal.mileage[type].uploadcare_image_urls &&
        appraisal.mileage[type].uploadcare_image_urls.length > 0) {
        if(appraisal.mileage[type].uploadcare_image_urls[0].includes("https://")){
          let jobId = this.state.jobId;
          
          appraisal.mileage[type].uploadcare_image_urls.forEach(function(i) {
            MileageImages.push(
              <img src={i}
                   onError={(e) => {
                     e.target.onerror = null;
                     e.target.src = "/images/placeholders/driver-app.png"
                   }}
                   key={'job-'+jobId+'-mileage-'+i} />
            );
          });
        }else if (appraisal.mileage &&
          appraisal.mileage[type] &&
          appraisal.mileage[type].photo_names &&
          appraisal.mileage[type].photo_names.length > 0) {
            let jobId = this.state.jobId;
         
          appraisal.mileage[type].photo_names.forEach(function(i) {
            MileageImages.push(
              <img src={"/storage/images/jobs/"+jobId+"/appraisal_images/"+i}
                   onError={(e) => {
                     e.target.onerror = null;
                     e.target.src = "/images/placeholders/driver-app.png"
                   }}
                   key={'job-'+jobId+'-mileage-'+i} />
            );
          });
        }
      }
      else if (appraisal.mileage &&
        appraisal.mileage[type] &&
        appraisal.mileage[type].photo_names &&
        appraisal.mileage[type].photo_names.length > 0) {
          let jobId = this.state.jobId;
        
        appraisal.mileage[type].photo_names.forEach(function(i) {
          MileageImages.push(
            <img src={"/storage/images/jobs/"+jobId+"/appraisal_images/"+i}
                 onError={(e) => {
                   e.target.onerror = null;
                   e.target.src = "/images/placeholders/driver-app.png"
                 }}
                 key={'job-'+jobId+'-mileage-'+i} />
          );
        });
      }
      return (
        <div className="appraisal-mileage-images-container">{MileageImages}</div>
      )
    }
    renderManualAppraisalPetrolLevelImages(appraisal, type) {
      let PetrolLevelImages = [];
      if (appraisal.petrol_level &&
        appraisal.petrol_level[type] &&
        appraisal.petrol_level[type].uploadcare_image_urls &&
        appraisal.petrol_level[type].uploadcare_image_urls.length > 0) {
        if(appraisal.petrol_level[type].uploadcare_image_urls[0].includes("https://")){
          let jobId = this.state.jobId;
          
          appraisal.petrol_level[type].uploadcare_image_urls.forEach(function(i) {
            PetrolLevelImages.push(
              <img src={i}
                   onError={(e) => {
                     e.target.onerror = null;
                     e.target.src = "/images/placeholders/driver-app.png"
                   }}
                   key={'job-'+jobId+'-petrol-'+i} />);
          });
        }else if (appraisal.petrol_level &&
          appraisal.petrol_level[type] &&
          appraisal.petrol_level[type].photo_names &&
          appraisal.petrol_level[type].photo_names.length > 0) {
            let jobId = this.state.jobId;
          
          appraisal.petrol_level[type].photo_names.forEach(function(i) {
            PetrolLevelImages.push(
              <img src={"/storage/images/jobs/"+jobId+"/appraisal_images/"+i}
                   onError={(e) => {
                     e.target.onerror = null;
                     e.target.src = "/images/placeholders/driver-app.png"
                   }}
                   key={'job-'+jobId+'-petrol-'+i} />);
          });
        }
      }else if (appraisal.petrol_level &&
        appraisal.petrol_level[type] &&
        appraisal.petrol_level[type].photo_names &&
        appraisal.petrol_level[type].photo_names.length > 0) {
          let jobId = this.state.jobId;
        
        appraisal.petrol_level[type].photo_names.forEach(function(i) {
          PetrolLevelImages.push(
            <img src={"/storage/images/jobs/"+jobId+"/appraisal_images/"+i}
                 onError={(e) => {
                   e.target.onerror = null;
                   e.target.src = "/images/placeholders/driver-app.png"
                 }}
                 key={'job-'+jobId+'-petrol-'+i} />);
        });
      }
      return (
        <div className="appraisal-petrol-level-images-container">
          {PetrolLevelImages}
        </div>
      )
    }
    renderManualAppraisalVehicleInfoLine(info) {
      if (!info || !info.label || !info.values) {
        return null;
      }
      if(info.label == "Uploadcare Photos" && info.values.length > 0){
        let additionalImages = [];
        let jobId = this.state.jobId;
         
        info.values.forEach(function(i,index) {
          additionalImages.push(
            <img className="img-responsive"
              src={i}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/placeholders/driver-app.png"
              }}
              key={'job-'+jobId+'-additional-photos-'+index} />);
        });
  
        return (
          <div className="appraisal-vehicle-info-line col-md-4 col-sm-12">
            <div className="appraisal-vehicle-info-line-label">Additional Images</div>
            <div className="appraisal-vehicle-info-line-value additional-images-block">{additionalImages}</div>
          </div>
        )
      }else{
        return (
          <div className="appraisal-vehicle-info-line col-md-4 col-sm-12">
            <div className="appraisal-vehicle-info-line-label">{info.label}</div>
            <div className="appraisal-vehicle-info-line-value">{info.values[0]}</div>
          </div>
        )
      }
    }
    renderManualAppraisalVehicleInfo(appraisal, type) {
      //if (this.state.data.manual_appraisal_required === 1 && appraisal.manual_appraisal) {
        //if (this.state.data.vehicle.type === 'car') {
          return (
            <div>
              <div className="appraisal-vehicle-info-line-container row">
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.aerial
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.clean_exterior
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.condition_of_sill
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.condition_of_tyres
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.does_it_smell_of_smoke
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.exterior_stickers_present
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.handbook
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.head_rests
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.inflation_kit
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.interior
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.locking_wheel_nut
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.number_of_carpet_mats
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.number_of_keys
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.parcel_shelf
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.sat_nav_disc_sd_card
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.service_book
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.spare_wheel
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.tool_and_jack
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.tread_depth
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.tyre_pressure
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.visibility
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.weather
                )}
  
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.notes
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.v5_registration_document
                )}
                {this.renderManualAppraisalVehicleInfoLine(
                  appraisal.manual_appraisal[type].vehicle_info.uploadcare_image_urls
                )}
              </div>
              {this.renderManualAppraisalVehiclePhotos(appraisal, type)}
            </div>
          );
       // }
  
        // if (this.state.data.vehicle.type === 'van') {
        //   return (
        //     <div>
        //       <div className="appraisal-vehicle-info-line-container row">
        //         {this.renderManualAppraisalVehicleInfoLine(
        //           appraisal.manual_appraisal[type].vehicle_info.aerial
        //         )}
        //         {this.renderManualAppraisalVehicleInfoLine(
        //           appraisal.manual_appraisal[type].vehicle_info.condition_of_sill
        //         )}
        //         {this.renderManualAppraisalVehicleInfoLine(
        //           appraisal.manual_appraisal[type].vehicle_info.condition_of_tyres
        //         )}
        //         {this.renderManualAppraisalVehicleInfoLine(
        //           appraisal.manual_appraisal[type].vehicle_info.clean_exterior
        //         )}
        //         {this.renderManualAppraisalVehicleInfoLine(
        //           appraisal.manual_appraisal[type].vehicle_info.does_it_smell_of_smoke
        //         )}
        //         {this.renderManualAppraisalVehicleInfoLine(
        //           appraisal.manual_appraisal[type].vehicle_info.exterior_stickers_present
        //         )}
        //         {this.renderManualAppraisalVehicleInfoLine(
        //           appraisal.manual_appraisal[type].vehicle_info.handbook
        //         )}
        //         {this.renderManualAppraisalVehicleInfoLine(
        //           appraisal.manual_appraisal[type].vehicle_info.head_rests
        //         )}
        //         {this.renderManualAppraisalVehicleInfoLine(
        //           appraisal.manual_appraisal[type].vehicle_info.interior
        //         )}
        //         {this.renderManualAppraisalVehicleInfoLine(
        //           appraisal.manual_appraisal[type].vehicle_info.inflation_kit
        //         )}
        //         {this.renderManualAppraisalVehicleInfoLine(
        //           appraisal.manual_appraisal[type].vehicle_info.tool_and_jack
        //         )}
        //         {this.renderManualAppraisalVehicleInfoLine(
        //           appraisal.manual_appraisal[type].vehicle_info.tread_depth
        //         )}
        //         {this.renderManualAppraisalVehicleInfoLine(
        //           appraisal.manual_appraisal[type].vehicle_info.tyre_pressure
        //         )}
        //         {this.renderManualAppraisalVehicleInfoLine(
        //           appraisal.manual_appraisal[type].vehicle_info.locking_wheel_nut
        //         )}
        //         {this.renderManualAppraisalVehicleInfoLine(
        //           appraisal.manual_appraisal[type].vehicle_info.number_of_carpet_mats
        //         )}
        //         {this.renderManualAppraisalVehicleInfoLine(
        //           appraisal.manual_appraisal[type].vehicle_info.number_of_keys
        //         )}
        //         {this.renderManualAppraisalVehicleInfoLine(
        //           appraisal.manual_appraisal[type].vehicle_info.parcel_shelf
        //         )}
        //         {this.renderManualAppraisalVehicleInfoLine(
        //           appraisal.manual_appraisal[type].vehicle_info.sat_nav_disc_sd_card
        //         )}
        //         {this.renderManualAppraisalVehicleInfoLine(
        //           appraisal.manual_appraisal[type].vehicle_info.service_book
        //         )}
        //         {this.renderManualAppraisalVehicleInfoLine(
        //           appraisal.manual_appraisal[type].vehicle_info.spare_wheel
        //         )}
        //         {this.renderManualAppraisalVehicleInfoLine(
        //           appraisal.manual_appraisal[type].vehicle_info.visibility
        //         )}
        //         {this.renderManualAppraisalVehicleInfoLine(
        //           appraisal.manual_appraisal[type].vehicle_info.weather
        //         )}
        //         {this.renderManualAppraisalVehicleInfoLine(
        //           appraisal.manual_appraisal[type].vehicle_info.notes
        //         )}
        //       </div>
        //       {
        //         this.renderManualAppraisalVehiclePhotos(
        //           appraisal,
        //           type
        //         )
        //       }
        //     </div>
        //   );
        // }
      // }
      // else {
      //   return <div>Manual Appraisal not required</div>
      // }
    }
    renderManualAppraisalVehiclePhotos(appraisal, type) {
      let ii = 0,
        ManualAppraisalVehiclePhotos = [];
  
      if (appraisal.manual_appraisal &&
        appraisal.manual_appraisal[type] &&
        appraisal.manual_appraisal[type].vehicle_info &&
        appraisal.manual_appraisal[type].vehicle_info.photo_names &&
        appraisal.manual_appraisal[type].vehicle_info.photo_names.length > 0) {
          let jobId = this.state.jobId;
         
        appraisal.manual_appraisal[type].vehicle_info.photo_names.forEach(function(i) {
          ii++;
          ManualAppraisalVehiclePhotos.push(
            <img
              src={"/storage/images/jobs/"+jobId+"/appraisal_images/"+i}
  
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/placeholders/driver-app.png"
              }}
              key={'job-'+jobId+'-vehicle-photos-'+ii} />);
        });
      }
      return (
        <div className="appraisal-images-container">{ManualAppraisalVehiclePhotos}</div>
      )
    }
    renderManualAppraisalVehicleParts(appraisal, type) {
      //if (this.state.data.manual_appraisal_required === 1 && appraisal.manual_appraisal && appraisal.manual_appraisal[type]) {
  
        //if (this.state.data.vehicle.type === 'car') {
          return (
            <div className="appraisal-vehicle-part-line-container row">
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.back_bumper
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.back_driver_alloy
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.back_driver_door
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.back_driver_panel
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.back_driver_tyre
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.back_driver_window
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.back_light_driver
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.back_light_passenger
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.back_passenger_alloy
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.back_passenger_door
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.back_passenger_panel
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.back_passenger_tyre
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.back_passenger_window
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.bonnet
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.boot
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.driver_head_light
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.driver_wing_mirror
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.front_bumper
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.front_driver_alloy
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.front_driver_door
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.front_driver_panel
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.front_driver_tyre
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.front_driver_window
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.front_passenger_alloy
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.front_passenger_door
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.front_passenger_panel
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.front_passenger_tyre
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.front_passenger_window
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.inside
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.passenger_head_light
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.passenger_wing_mirror
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.rear_window
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.roof
              )}
              {this.renderManualAppraisalVehiclePartLine(
                appraisal.manual_appraisal[type].vehicle_parts.windscreen
              )}
            </div>
          );
        //}
  
      //   if (this.state.data.vehicle.type === 'van') {
      //     return (
      //       <div className="appraisal-vehicle-part-line-container row">
      //         {this.renderManualAppraisalVehiclePartLine(
      //           appraisal.manual_appraisal[type].vehicle_parts.back_bumper
      //         )}
      //         {this.renderManualAppraisalVehiclePartLine(
      //           appraisal.manual_appraisal[type].vehicle_parts.back_door
      //         )}
      //         {this.renderManualAppraisalVehiclePartLine(
      //           appraisal.manual_appraisal[type].vehicle_parts.back_driver_tyre
      //         )}
      //         {this.renderManualAppraisalVehiclePartLine(
      //           appraisal.manual_appraisal[type].vehicle_parts.back_driver_alloy
      //         )}
      //         {this.renderManualAppraisalVehiclePartLine(
      //           appraisal.manual_appraisal[type].vehicle_parts.back_passenger_tyre
      //         )}
      //         {this.renderManualAppraisalVehiclePartLine(
      //           appraisal.manual_appraisal[type].vehicle_parts.back_passenger_alloy
      //         )}
      //         {this.renderManualAppraisalVehiclePartLine(
      //           appraisal.manual_appraisal[type].vehicle_parts.bonnet
      //         )}
      //         {this.renderManualAppraisalVehiclePartLine(
      //           appraisal.manual_appraisal[type].vehicle_parts.driver_side_front_panel
      //         )}
      //         {this.renderManualAppraisalVehiclePartLine(
      //           appraisal.manual_appraisal[type].vehicle_parts.driver_side_window
      //         )}
      //         {this.renderManualAppraisalVehiclePartLine(
      //           appraisal.manual_appraisal[type].vehicle_parts.driver_wing_mirror
      //         )}
      //         {this.renderManualAppraisalVehiclePartLine(
      //           appraisal.manual_appraisal[type].vehicle_parts.driver_door
      //         )}
      //         {this.renderManualAppraisalVehiclePartLine(
      //           appraisal.manual_appraisal[type].vehicle_parts.driver_side
      //         )}
      //         {this.renderManualAppraisalVehiclePartLine(
      //           appraisal.manual_appraisal[type].vehicle_parts.driver_head_light
      //         )}
      //         {this.renderManualAppraisalVehiclePartLine(
      //           appraisal.manual_appraisal[type].vehicle_parts.front_bumper
      //         )}
      //         {this.renderManualAppraisalVehiclePartLine(
      //           appraisal.manual_appraisal[type].vehicle_parts.front_driver_tyre
      //         )}
      //         {this.renderManualAppraisalVehiclePartLine(
      //           appraisal.manual_appraisal[type].vehicle_parts.front_driver_alloy
      //         )}
      //         {this.renderManualAppraisalVehiclePartLine(
      //           appraisal.manual_appraisal[type].vehicle_parts.front_passenger_tyre
      //         )}
      //         {this.renderManualAppraisalVehiclePartLine(
      //           appraisal.manual_appraisal[type].vehicle_parts.front_passenger_alloy
      //         )}
      //         {this.renderManualAppraisalVehiclePartLine(
      //           appraisal.manual_appraisal[type].vehicle_parts.inside
      //         )}
      //         {this.renderManualAppraisalVehiclePartLine(
      //           appraisal.manual_appraisal[type].vehicle_parts.passenger_door
      //         )}
      //         {this.renderManualAppraisalVehiclePartLine(
      //           appraisal.manual_appraisal[type].vehicle_parts.passenger_side
      //         )}
      //         {this.renderManualAppraisalVehiclePartLine(
      //           appraisal.manual_appraisal[type].vehicle_parts.passenger_head_light
      //         )}
      //         {this.renderManualAppraisalVehiclePartLine(
      //           appraisal.manual_appraisal[type].vehicle_parts.passenger_side_window
      //         )}
      //         {this.renderManualAppraisalVehiclePartLine(
      //           appraisal.manual_appraisal[type].vehicle_parts.passenger_wing_mirror
      //         )}
      //         {this.renderManualAppraisalVehiclePartLine(
      //           appraisal.manual_appraisal[type].vehicle_parts.passenger_side_front_panel
      //         )}
      //         {this.renderManualAppraisalVehiclePartLine(
      //           appraisal.manual_appraisal[type].vehicle_parts.slide_door
      //         )}
      //         {this.renderManualAppraisalVehiclePartLine(
      //           appraisal.manual_appraisal[type].vehicle_parts.tail_light_driver
      //         )}
      //         {this.renderManualAppraisalVehiclePartLine(
      //           appraisal.manual_appraisal[type].vehicle_parts.tail_light_passenger
      //         )}
      //         {this.renderManualAppraisalVehiclePartLine(
      //           appraisal.manual_appraisal[type].vehicle_parts.windscreen
      //         )}
      //       </div>
      //     );
      //   }
      // }
      // else {
      //   return (<div>Manual Appraisal not required</div> )
      // }
    }
    renderManualAppraisalVehiclePartLine(part) {
      let ii = 0, VehiclePartImages = [], VehiclePartDamages = [];
      if (!part) {
        return false;
      }
      let keyPart = part.label.replace(/\s+/g, '-').toLowerCase();
      if (part && part.uploadcare_image_urls && part.uploadcare_image_urls.length > 0) {
        if(part.uploadcare_image_urls[0].includes("https://")){
          let jobId = this.state.jobId;
          
          part.uploadcare_image_urls.forEach(function(i) {
            ii++
            VehiclePartImages.push(
              <img src={i}
                   onError={(e) => {
                     e.target.onerror = null;
                     e.target.src = "/images/placeholders/driver-app.png"
                   }}
  
                   key={'job-'+jobId+'-part-'+ii+'-'+keyPart} />
            );
          });
        }else if (part && part.photo_names && part.photo_names.length > 0) {
          let jobId = this.state.jobId;
          
          part.photo_names.forEach(function(i) {
            ii++;
            VehiclePartImages.push(
              <img
                src={"/storage/images/jobs/"+jobId+"/appraisal_images/"+i}
                onError={(e) => {
                     e.target.onerror = null;
                     e.target.src = "/images/placeholders/driver-app.png"
                   }}
  
                   key={'job-'+jobId+'-part-'+ii+'-'+keyPart} />
            );
          });
        }
      }else if (part && part.photo_names && part.photo_names.length > 0) {
        let jobId = this.state.jobId;
        
        part.photo_names.forEach(function(i) {
          ii++;
          VehiclePartImages.push(
            <img
              src={"/storage/images/jobs/"+jobId+"/appraisal_images/"+i}
              onError={(e) => {
                   e.target.onerror = null;
                   e.target.src = "/images/placeholders/driver-app.png"
                 }}
  
                 key={'job-'+jobId+'-part-'+ii+'-'+keyPart} />
          );
        });
      }
  
      if (part && part.damages && part.damages.values &&
        part.damages.values.length > 0) {
          let jobId = this.state.jobId;
        part.damages.values.forEach(function(i) {
          ii++;
          VehiclePartDamages.push(
            <div key={'job-'+jobId+'-damage-'+ii+'-'+keyPart}
                 className="vehicle-damage-label">{i}</div>
          );
        });
      }
  
      return (
        <div className="appraisal-vehicle-part-line col-md-6 col-sm-12">
          <div className="appraisal-vehicle-part-line-label">
            {part.label}
          </div>
          <div className="appraisal-vehicle-part-line-damages">
            {ii > 0 ?
              <strong>Damages:</strong>
              : null }
            {VehiclePartDamages}
          </div>
          <div className="appraisal-vehicle-part-line-images">
            {VehiclePartImages}
          </div>
        </div>
      )
    }
    render() {
        return (
            <div className="container-fluid">
                {this.state.isLoading ? 
                    <div className="loading-box">
                      <span className="add-loading-text">
                        <i className="fa fa-spinner fa-pulse"></i>
                      </span>
                    </div> : '' }
                  
            { (this.state.appraisalSplitData != null) ? this.renderAppraisalInfoBlock('pickup') : '' }
            </div>
        );
    }
}
if (document.getElementById('react-component-g4-logistics-portal-jobs-apprisal-split-data')) {
    let jobId = document.getElementById('react-component-g4-logistics-portal-jobs-apprisal-split-data').getAttribute("data-jobId");
    ReactDOM.render(
        <JobAppraisalSplitData jobId={jobId} message_if_none = 'Nothing to report on.' />,
        document.getElementById('react-component-g4-logistics-portal-jobs-apprisal-split-data')
    );
}
